import React from "react";
import { Link } from "react-router-dom";

function ServiceSection() {
  return (
    <div>
      <div className="service-section bg-white">
        <div className="divider"></div>

        <div className="container">
          <div className="row g-5 g-xl-0">
            {/* Service Card */}
            <div className="col-12 col-sm-6 col-xl-3">
              <div
                className="service-card wow fadeInUp"
                data-wow-delay="300ms"
                data-wow-duration="1000ms"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1_1757)">
                    <mask
                      id="mask0_1_1757"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="-1"
                      width="60"
                      height="61"
                    >
                      <path
                        d="M0 -0.0292931H60V60H0V-0.0292931Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0_1_1757)">
                      <path
                        d="M58.8281 33.543V36.8841C58.8281 39.4421 56.7555 41.5157 54.1989 41.5157H48.5084V55.7834C48.5084 57.4649 47.1458 58.8281 45.4651 58.8281C43.7844 58.8281 42.4219 57.4649 42.4219 55.7834V39.7179C42.4219 36.3076 45.1852 33.543 48.5938 33.543"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M58.8276 41.5157H48.5078V58.8281H58.8276V41.5157Z"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1.17188 33.543V36.8841C1.17188 39.4421 3.24445 41.5157 5.80113 41.5157H11.4916V55.7834C11.4916 57.4649 12.8542 58.8281 14.5349 58.8281C16.2156 58.8281 17.5781 57.4649 17.5781 55.7834V39.7179C17.5781 36.3076 14.8148 33.543 11.4062 33.543"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M40.7812 20.6445V17.2437C40.7812 14.152 38.2761 11.6456 35.1859 11.6456H24.8141C21.7239 11.6456 19.2188 14.152 19.2188 17.2437V20.6445"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M30.0002 1.14566C27.5483 1.14566 25.5605 3.13436 25.5605 5.58747V7.20662C25.5605 9.65973 27.5483 11.6484 30.0002 11.6484C32.4521 11.6484 34.4398 9.65973 34.4398 7.20662V5.58747C34.4398 3.13436 32.4521 1.14566 30.0002 1.14566Z"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M19.8047 33.5431H1.17188V18.474C1.17188 15.5706 3.52441 13.217 6.42644 13.217C8.76351 13.217 10.8198 14.7613 11.4722 17.0067C12.139 19.302 14.241 20.8807 16.6301 20.8807H21.4453V26.0394"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M5.88891 3.8618C8.0734 3.8618 9.84422 5.63348 9.84422 7.81904V9.26151C9.84422 11.4469 8.0734 13.2188 5.88891 13.2188C3.70441 13.2188 1.93359 11.4469 1.93359 9.26151V7.81904C1.93359 5.63348 3.70441 3.8618 5.88891 3.8618Z"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M13.3399 26.0391H13.2656C10.5277 26.0391 8.03691 24.4549 6.875 21.9745"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M40.1953 33.5431H58.8281V18.474C58.8281 15.5706 56.4756 13.217 53.5736 13.217C51.2365 13.217 49.1802 14.7613 48.5278 17.0067C47.861 19.302 45.759 20.8807 43.3699 20.8807H38.5547V26.0394"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M54.1116 3.8618C51.9271 3.8618 50.1562 5.63348 50.1562 7.81904V9.26151C50.1562 11.4469 51.9271 13.2188 54.1116 13.2188C56.2961 13.2188 58.0669 11.4469 58.0669 9.26151V7.81904C58.0669 5.63348 56.2961 3.8618 54.1116 3.8618Z"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M46.6602 26.0391H46.7345C49.4723 26.0391 51.9631 24.4549 53.125 21.9745"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M1.17188 41.5155H11.4916V58.828H1.17188V41.5155Z"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M50.1562 33.543H9.84375V26.0393H50.1562V33.543Z"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M30 40.6761V55.897C30 57.5159 28.6883 58.8281 27.0703 58.8281C25.4523 58.8281 24.1406 57.5159 24.1406 55.897V33.5431H30"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M35.8594 49.9961V55.897C35.8594 57.5158 34.5477 58.8281 32.9297 58.8281C31.3117 58.8281 30 57.5158 30 55.897V43.0391"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M30 33.5443H35.8594V39.4453"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M24.1406 58.8281H17.5781V33.543H24.1406V58.8281Z"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M35.8594 33.543H42.4219V58.8281H35.8594V55.897"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_1_1757">
                      <rect width="60" height="60" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <div className="service-title">Corporate Security</div>
                <p>
                  Our law firm's securitie there attorneys understand that there
                  is a difference.
                </p>
                <Link to="/casestudy" className="btn btn-link">
                  Read More <i className="ti ti-arrow-up-right"></i>
                </Link>
              </div>
            </div>

            {/* Service Card */}
            <div className="col-12 col-sm-6 col-xl-3">
              <div
                className="service-card wow fadeInUp"
                data-wow-delay="500ms"
                data-wow-duration="1000ms"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1_1660)">
                    <mask
                      id="mask0_1_1660"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="60"
                      height="60"
                    >
                      <path d="M60 0H0V60H60V0Z" fill="white" />
                      <path
                        d="M15.9375 33.5156C16.5844 33.5156 17.1094 34.0406 17.1094 34.6875C17.1094 35.3344 16.5844 35.8594 15.9375 35.8594C15.2906 35.8594 14.7656 35.3344 14.7656 34.6875C14.7656 34.0406 15.2906 33.5156 15.9375 33.5156Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0_1_1660)">
                      <mask
                        id="mask1_1_1660"
                        style={{ maskType: "luminance" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="60"
                        height="60"
                      >
                        <path
                          d="M0 3.8147e-06H60V60H0V3.8147e-06Z"
                          fill="white"
                        />
                      </mask>
                      <g mask="url(#mask1_1_1660)">
                        <path
                          d="M15.9375 33.5156C16.5844 33.5156 17.1094 34.0406 17.1094 34.6875C17.1094 35.3344 16.5844 35.8594 15.9375 35.8594C15.2906 35.8594 14.7656 35.3344 14.7656 34.6875C14.7656 34.0406 15.2906 33.5156 15.9375 33.5156Z"
                          fill="#D3A574"
                        />
                        <path
                          d="M48.75 18.2812H55.7812V4.6875C55.7812 2.7457 54.2074 1.17188 52.2656 1.17188H52.2644C50.3227 1.17305 48.75 2.7457 48.75 4.6875V55.3125C48.75 57.2543 47.1762 58.8281 45.2344 58.8281M45.2344 58.8281C44.2641 58.8281 43.3852 58.4344 42.7488 57.798C42.1125 57.1617 41.7187 56.2828 41.7187 55.3125V51.7969H4.21875V54.1406C4.21875 56.7293 6.31758 58.8281 8.90625 58.8281H45.2344Z"
                          stroke="#D3A574"
                          strokeWidth="2.34375"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M8.90625 51.7969V5.85938C8.90625 3.2707 11.0051 1.17188 13.5937 1.17188H52.2644"
                          stroke="#D3A574"
                          strokeWidth="2.34375"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M32.3437 19.452C30.9199 18.3832 30 16.6815 30 14.7656C30 11.53 32.6238 8.90625 35.8594 8.90625C39.0949 8.90625 41.7187 11.53 41.7187 14.7656C41.7187 16.6815 40.7988 18.3832 39.375 19.452C38.3953 20.1891 37.1777 20.625 35.8594 20.625C34.541 20.625 33.3234 20.1891 32.3437 19.452Z"
                          stroke="#D3A574"
                          strokeWidth="2.34375"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M39.375 19.4531V27.6562L35.8594 25.3125L32.3438 27.6562V19.4531"
                          stroke="#D3A574"
                          strokeWidth="2.34375"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M20.625 34.6875H41.7188"
                          stroke="#D3A574"
                          strokeWidth="2.34375"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.9375 41.7188H41.7187"
                          stroke="#D3A574"
                          strokeWidth="2.34375"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.9375 11.25H25.3125"
                          stroke="#D3A574"
                          strokeWidth="2.34375"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.9375 18.2812H25.3125"
                          stroke="#D3A574"
                          strokeWidth="2.34375"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.9375 25.3125H25.3125"
                          stroke="#D3A574"
                          strokeWidth="2.34375"
                          strokeMiterlimit="10"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </g>
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_1_1660">
                      <rect width="60" height="60" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <div className="service-title">Bankruptcy law</div>
                <p>
                  Our law firm's securitie there attorneys understand that there
                  is a difference.
                </p>
                <Link to="/casestudy" className="btn btn-link">
                  Read More <i className="ti ti-arrow-up-right"></i>
                </Link>
              </div>
            </div>

            {/* Service Card */}
            <div className="col-12 col-sm-6 col-xl-3">
              <div
                className="service-card wow fadeInUp"
                data-wow-delay="700ms"
                data-wow-duration="1000ms"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1_1700)">
                    <mask
                      id="mask0_1_1700"
                      style={{ maskType: "luminance" }}
                      maskUnits="userSpaceOnUse"
                      x="0"
                      y="0"
                      width="60"
                      height="60"
                    >
                      <path
                        d="M0 3.8147e-06H60V60H0V3.8147e-06Z"
                        fill="white"
                      />
                    </mask>
                    <g mask="url(#mask0_1_1700)">
                      <path
                        d="M19.4531 57.6562H9.60938V55.4039V43.2422C11.8887 40.5251 15.2535 38.9558 18.8 38.9558H19.2854C22.1528 38.9558 24.9643 39.7477 27.4102 41.2441L29.3107 42.407H38.5602C40.5585 42.407 42.1784 44.0269 42.1784 46.0252C42.1784 48.0234 40.5585 49.6433 38.5602 49.6433L26.5235 49.6406H38.6554C39.471 49.6406 40.2594 49.3481 40.8777 48.8163L53.4938 37.9655C54.4429 37.1586 55.7706 36.968 56.9084 37.4752C58.9815 38.3994 59.4845 41.1148 57.8798 42.7201L46.8716 53.734C44.3616 56.2453 40.9564 57.6562 37.4058 57.6562H30"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M2.34375 39.1406H8.4375C9.08473 39.1406 9.60938 39.6653 9.60938 40.3125V57.6563C9.60938 58.3035 9.08473 58.8281 8.4375 58.8281H2.34375C1.69652 58.8281 1.17188 58.3035 1.17188 57.6563V40.3125C1.17188 39.6653 1.69652 39.1406 2.34375 39.1406Z"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M17.3438 18.4664V26.9768C17.3438 27.2588 17.4863 27.5217 17.7226 27.6756L26.6075 33.461C27.8149 34.2474 29.3726 34.2474 30.58 33.461L39.4649 27.6756C39.7012 27.5217 39.8438 27.2588 39.8438 26.9768V18.4664"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M7.96484 12.9527L28.5942 1.1709L49.2236 12.9527L28.5942 24.7344L7.96484 12.9527Z"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M46.4102 32.2578H52.0352V22.5356C52.0352 20.9823 50.776 19.7231 49.2227 19.7231C47.6693 19.7231 46.4102 20.9823 46.4102 22.5356V32.2578Z"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M26.25 13.0625C26.25 11.768 27.2993 10.7188 28.5937 10.7188C29.8882 10.7188 30.9375 11.768 30.9375 13.0625C30.9375 14.357 29.8882 15.4062 28.5937 15.4062C27.2993 15.4062 26.25 14.357 26.25 13.0625Z"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M49.2236 19.0703V12.9516H30.9375"
                        stroke="#D3A574"
                        strokeWidth="2.34375"
                        strokeMiterlimit="10"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_1_1700">
                      <rect width="60" height="60" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <div className="service-title">Education Law</div>
                <p>
                  Our law firm's securitie there attorneys understand that there
                  is a difference.
                </p>
                <Link to="/casestudy" className="btn btn-link">
                  Read More <i className="ti ti-arrow-up-right"></i>
                </Link>
              </div>
            </div>

            {/* Service Card */}
            <div className="col-12 col-sm-6 col-xl-3">
              <div
                className="service-card border-0 wow fadeInUp"
                data-wow-delay="900ms"
                data-wow-duration="1000ms"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="60"
                  height="60"
                  viewBox="0 0 60 60"
                  fill="none"
                >
                  <g clipPath="url(#clip0_1_1728)">
                    <path
                      d="M58.7909 45.5216L58.6804 45.4111C57.3756 44.1064 55.4427 43.745 53.7892 44.4096V25.7811H58.2609C58.7351 25.7811 59.1625 25.4954 59.3438 25.0574C59.525 24.6193 59.4245 24.115 59.089 23.7801L35.6214 0.342627C35.1639 -0.114287 34.4225 -0.11417 33.965 0.342744L27.5223 6.77915C27.0645 7.23653 27.064 7.97856 27.5215 8.43641C27.979 8.89438 28.721 8.89474 29.1788 8.43724L34.7934 2.82817L55.4291 23.4374H51.2796L35.6213 7.79915C35.1637 7.34224 34.4225 7.34224 33.965 7.79915L18.3068 23.4374H14.1572L22.6499 14.9557C23.1079 14.4983 23.1083 13.7564 22.6509 13.2984C22.1936 12.8404 21.4516 12.84 20.9937 13.2974L10.4974 23.7801C10.1619 24.1152 10.0614 24.6193 10.2427 25.0574C10.4239 25.4954 10.8513 25.7811 11.3255 25.7811H15.8203V35.7579H14.0918V35.1903C14.0918 33.0713 12.368 31.3475 10.249 31.3475H1.17188C0.524648 31.3475 0 31.8723 0 32.5194V58.828C0 59.4751 0.524648 59.9999 1.17188 59.9999H10.249C12.3679 59.9999 14.0918 58.276 14.0918 56.157V55.6734L17.1709 57.5383C19.8299 59.1487 22.8784 60 25.9869 60H43.0048C46.3289 60 49.5821 58.8478 52.1653 56.7554L58.47 51.6488C59.3776 50.9137 59.9332 49.8231 59.9943 48.6566C60.0553 47.4901 59.6167 46.3475 58.7909 45.5216ZM11.748 56.157C11.748 56.9837 11.0756 57.6561 10.249 57.6561H2.34375V33.6913H10.249C11.0755 33.6913 11.748 34.3637 11.748 35.1903V56.157ZM18.1641 25.7811H18.7917C19.1023 25.7811 19.4 25.6578 19.6198 25.4384L34.7932 10.2846L49.9665 25.4384C50.1863 25.6579 50.4841 25.7811 50.7946 25.7811H51.4453V45.8497C51.4453 45.8925 51.4479 45.9345 51.4523 45.976L48.9763 47.8381C48.8161 47.0673 48.4512 46.346 47.9003 45.7951C47.2362 45.1311 46.3534 44.7655 45.4144 44.7655H42.5276V28.0077C42.5276 27.3604 42.0029 26.8358 41.3557 26.8358H28.2307C27.5835 26.8358 27.0588 27.3604 27.0588 28.0077V36.9572C25.9071 36.1775 24.5504 35.7579 23.1288 35.7579H18.1641V25.7811ZM40.1838 29.1795V44.7655H35.9904C35.3644 44.7655 34.7759 44.5217 34.3351 44.0809L29.3938 39.1165C29.3991 39.0712 29.4026 39.0255 29.4026 38.9789V29.1795H40.1838ZM57.6538 48.534C57.627 49.0456 57.3929 49.505 56.9948 49.8275L50.6902 54.9341C48.523 56.6894 45.7936 57.6561 43.0048 57.6561H25.9869C23.3065 57.6561 20.6777 56.922 18.3851 55.5335L14.0918 52.9332V38.1016H23.1288C24.3809 38.1016 25.558 38.5892 26.4415 39.4727L32.6759 45.7363C33.5613 46.6216 34.7384 47.1092 35.9904 47.1092H45.4144C45.7274 47.1092 46.0218 47.2311 46.243 47.4525C46.7803 47.9898 46.8238 48.8749 46.5918 49.4348C46.5225 49.602 46.4409 49.7215 46.3566 49.8083L46.2967 49.8533C46.3004 49.854 46.3037 49.8546 46.3075 49.8553C46.104 50.0329 45.8945 50.034 45.8058 50.034H31.7578C30.9479 50.034 30.1611 49.8007 29.4824 49.3591L25.7217 46.9132L25.708 46.9043C25.166 46.5507 24.4399 46.7029 24.0861 47.245C23.7323 47.787 23.8849 48.5131 24.4269 48.8669L28.2045 51.3239C29.2644 52.0133 30.4931 52.3777 31.7578 52.3777H45.8057C46.5921 52.3777 47.301 52.1034 47.8586 51.6112L54.2532 46.8022C55.1201 46.2164 56.2818 46.3268 57.023 47.0683L57.1336 47.1788C57.4958 47.5411 57.6806 48.0224 57.6538 48.534Z"
                      fill="#D3A574"
                    />
                    <path
                      d="M47.5781 34.0586C46.9309 34.0586 46.4062 34.5834 46.4062 35.2305V42.6571C46.4062 43.3042 46.9309 43.829 47.5781 43.829C48.2254 43.829 48.75 43.3042 48.75 42.6571V35.2305C48.75 34.5834 48.2254 34.0586 47.5781 34.0586Z"
                      fill="#D3A574"
                    />
                    <path
                      d="M48.4066 29.941C48.1887 29.7219 47.8863 29.5977 47.5781 29.5977C47.2699 29.5977 46.9676 29.7219 46.7496 29.941C46.5316 30.1589 46.4062 30.4602 46.4062 30.7694C46.4062 31.0777 46.5316 31.3801 46.7496 31.5979C46.9676 31.816 47.2699 31.9413 47.5781 31.9413C47.8863 31.9413 48.1887 31.816 48.4066 31.5979C48.6246 31.3801 48.75 31.0777 48.75 30.7694C48.75 30.46 48.6246 30.1589 48.4066 29.941Z"
                      fill="#D3A574"
                    />
                    <path
                      d="M32.9125 36.1C32.6945 35.8822 32.3922 35.7578 32.084 35.7578C31.7746 35.7578 31.4734 35.8822 31.2543 36.1C31.0363 36.3191 30.9121 36.6203 30.9121 36.9285C30.9121 37.2379 31.0363 37.5391 31.2543 37.7582C31.4734 37.9762 31.7758 38.1016 32.084 38.1016C32.3922 38.1016 32.6934 37.9762 32.9125 37.7582C33.1305 37.5391 33.2559 37.2379 33.2559 36.9285C33.2559 36.6203 33.1305 36.3191 32.9125 36.1Z"
                      fill="#D3A574"
                    />
                    <path
                      d="M25.9147 10.0384C25.457 9.58079 24.715 9.58079 24.2573 10.0384C23.7997 10.496 23.7997 11.2381 24.2573 11.6958L24.2575 11.6959C24.4864 11.9248 24.7861 12.039 25.086 12.039C25.3859 12.039 25.6859 11.9245 25.9147 11.6958C26.3723 11.2382 26.3722 10.496 25.9147 10.0384Z"
                      fill="#D3A574"
                    />
                    <path
                      d="M34.793 15.4294C32.2729 15.4294 30.2227 17.4796 30.2227 19.9998C30.2227 22.5199 32.2729 24.5701 34.793 24.5701C37.3131 24.5701 39.3633 22.5199 39.3633 19.9998C39.3633 17.4796 37.3131 15.4294 34.793 15.4294ZM34.793 22.2263C33.5652 22.2263 32.5664 21.2275 32.5664 19.9998C32.5664 18.772 33.5652 17.7732 34.793 17.7732C36.0207 17.7732 37.0195 18.772 37.0195 19.9998C37.0195 21.2275 36.0207 22.2263 34.793 22.2263Z"
                      fill="#D3A574"
                    />
                    <path
                      d="M7.87344 51.6715C7.65547 51.4534 7.3543 51.3281 7.04492 51.3281C6.73672 51.3281 6.43555 51.4534 6.21641 51.6715C5.99844 51.8895 5.87305 52.1918 5.87305 52.5C5.87305 52.8082 5.99844 53.1105 6.21641 53.3284C6.43555 53.5464 6.73672 53.6719 7.04492 53.6719C7.3543 53.6719 7.65547 53.5465 7.87344 53.3284C8.09258 53.1105 8.2168 52.8082 8.2168 52.5C8.2168 52.1918 8.09258 51.8895 7.87344 51.6715Z"
                      fill="#D3A574"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_1_1728">
                      <rect width="60" height="60" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
                <div className="service-title">Real Estate Law</div>
                <p>
                  Our law firm's securitie there attorneys understand that there
                  is a difference.
                </p>
                <Link to="/casestudy" className="btn btn-link">
                  Read More <i className="ti ti-arrow-up-right"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="divider"></div>
      </div>
    </div>
  );
}

export default ServiceSection;
